/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useContext } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { getApiTargetInfo } from 'core'
import { getCauseCodeMap } from 'core/selectors'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  getSystemCompMgmtInfo,
  postSystemCompMgmtInfo,
  deleteSystemCompMgmtInfo,
  getUnitTypeInfo,
  getUnitCodeSystemCompMap,
  getUnitSystemCompCauseCodeMap,
  getCauseCodeAll,
} from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { Button, Select, InputNumber, Input } from 'antd'
import {
  CAUSE_CODE,
  STORE_CAUSE_CODE_MAP,
  STORE_UNIT_CAUSE_CODE_MAP,
} from 'core/action-names'
import { ErrorContext } from 'context'

const headers = [
  strCol({
    ident: 'unitCode',
    display: 'Unit Code',
    isKey: true,
  }),
  strCol({
    ident: 'system',
    display: 'System',
    isKey: true,
    width: 300,
  }),
  strCol({
    ident: 'component',
    display: 'Component',
    isKey: true,
    width: 325,
  }),
  strCol({
    ident: 'causeCode',
    display: 'Cause Code',
    isKey: true,
  }),
  strCol({
    ident: 'causeCode',
    display: 'Description',
    width: 600,
    alignment: 'left',
    inserted: false,
    isEditable: false,
    isKey: true,
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getSystemCompMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postSystemCompMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteSystemCompMgmtInfo(apiTargetInfo)(data)

const title = 'System/Component Management'

const processUnitTypes = R.compose(
  R.fromPairs,
  R.map(a => [a.unitCode, a.unitCode])
)

const SystemCompMgmt = props => {
  const [unitTypes, setUnitTypes] = useState({})
  const [unitCodeSystem, setUnitCodeSystem] = useState({})
  const [systemComponent, setSystemComponent] = useState({})
  const [insertEvent, setInsertEvent] = useState(false)
  const { setError } = useContext(ErrorContext)

  const generateDataGetter = ({ rowData, header }) => {
    if (header.ident === 'system') header.choices = []
    if (header.ident === 'component') header.choices = []
    if (rowData.unitCode !== '' && rowData.unitCode !== undefined) {
      if (header.ident === 'system') {
        const systemList = unitCodeSystem && unitCodeSystem[rowData.unitCode]
        header.choices = systemList
          ? systemList
              .filter((elem, pos, arr) => {
                return arr.indexOf(elem) === pos
              })
              .map(value => ({
                text: value,
                value,
              }))
          : []

        return rowData.system
      }
    }
    if (rowData.system !== '' && rowData.system !== undefined) {
      if (header.ident === 'component') {
        const componentList = systemComponent && systemComponent[rowData.system]
        header.choices = componentList
          ? componentList
              .filter((elem, pos, arr) => {
                return arr.indexOf(elem) === pos
              })
              .map(value => ({
                text: value,
                value,
              }))
          : []

        return rowData.component
      }
    }
  }

  useEffect(() => {
    getUnitTypeInfo(props.apiTargetInfo)
      .map(processUnitTypes)
      .fork(setError, unitTypes => setUnitTypes(unitTypes))

    getUnitCodeSystemCompMap(props.apiTargetInfo).fork(
      setError,
      unitCodeSystemComp => {
        setUnitCodeSystem(unitCodeSystemComp['UNITCODE-SYSTEM'])
        setSystemComponent(unitCodeSystemComp['SYSTEM-COMPONENT'])
      }
    )
  }, [props.apiTargetInfo, setError])

  const afterSaveTask = _ => {
    getUnitSystemCompCauseCodeMap(props.apiTargetInfo).fork(setError, data =>
      props.saveSystemCopmCauseCode(data)
    )
    getCauseCodeAll(props.apiTargetInfo).fork(setError, data =>
      props.saveCauseCode(data)
    )
  }

  // const validateInsert = _ => {
  //   const { system, causeCode, unitCode, component } = insertObj
  //   if (unitCode == undefined) message.error('Please , Select Unit Code')
  //   if (system == undefined) message.error('Please , Select System')
  //   if (component == undefined) message.error('Please , Select Component')
  //   if (causeCode == undefined) message.error('Please , Select Cause Code')
  //   else return true

  //   return false
  // }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 200px 80px 200px 100px 200px 100px 150px',
          gridColumnGap: '5px',
          gridRowGap: '10px',
        }}
      >
        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Unit Code :
        </div>

        <Select
          id="unit"
          value={insertData.unitCode}
          onChange={e => setInsertData({ ...insertData, unitCode: e })}
        >
          {Object.keys(unitCodeSystem).map(r => (
            <Select.Option key={r}>{r}</Select.Option>
          ))}
        </Select>

        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          System :{' '}
        </div>

        <Select
          id="system"
          value={insertData.system}
          onChange={e =>
            setInsertData({ ...insertData, system: e, component: '' })
          }
        >
          {(unitCodeSystem[insertData.unitCode] || []).map(r => (
            <Select.Option key={r}>{r}</Select.Option>
          ))}
        </Select>

        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Component :{' '}
        </div>

        <Select
          id="component"
          value={insertData.component}
          onChange={e => setInsertData({ ...insertData, component: e })}
        >
          {systemComponent[insertData.system || 'Miscellaneous'].map(r => (
            <Select.Option key={r}>{r}</Select.Option>
          ))}
        </Select>

        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Cause Code :{' '}
        </div>

        <InputNumber
          placeholder="Cause Code"
          value={insertData.causeCode || 0}
          onChange={e => setInsertData({ ...insertData, causeCode: e })}
          min={0}
          style={{ display: 'grid', width: 'auto' }}
        />

        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Code Description :
        </div>
        <div
          style={{
            gridColumnEnd: 'span 5',
            fontSize: 'large',
            color: props.causeCodeMap[insertData.causeCode] ? 'blue' : 'red',
          }}
        >
          <Input
            rows={1}
            value={
              props.causeCodeMap[insertData.causeCode] ||
              'Cause Code description not found'
            }
            disabled
            style={{
              color: props.causeCodeMap[insertData.causeCode] ? 'blue' : 'red',
            }}
          />
        </div>
        <div
          style={{
            display: 'grid',
            gap: '5px',
            gridColumnEnd: 'span 1',
            gridTemplateColumns: 'auto auto auto',
          }}
        >
          <Button onClick={() => onAdd(true)} type="primary">
            Add
          </Button>
          <Button onClick={() => onAdd(false)} type="primary">
            Add & Hide
          </Button>

          <Button onClick={onCancel} type="danger">
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitCode'
      ? {
          ...header,
          ...toSelectionColProps(unitTypes),
          dataFormatter: ({ value }) => unitTypes[value] || value,
        }
      : header.display === 'Description'
      ? {
          ...header,
          dataFormatter: ({ value }) => props.causeCodeMap[value],
          sortIndexGetter: ({ rowData }) =>
            props.causeCodeMap[rowData.causeCode] || rowData.causeCode,
        }
      : header.ident === 'system'
      ? {
          ...header,
          choices: [],
          dataGetter: generateDataGetter,
        }
      : header.ident === 'component'
      ? {
          ...header,
          choices: [],
          dataGetter: generateDataGetter,
        }
      : header.display === 'causeCode'
      ? {
          ...header,
          // dataFormatter: ({ value }) => props.causeCodeMap[value],
          sortIndexGetter: ({ rowData }) =>
            props.causeCodeMap[rowData.causeCode] || rowData.causeCode,
        }
      : header
  )

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.unitCode}
      autoRetrieve
      sortOptions={[
        { ident: 'unitCode', display: 'Unit Code', sortOrder: 'asc' },
        { ident: 'system', display: 'System', sortOrder: 'asc' },
        { ident: 'component', display: 'Component', sortOrder: 'asc' },
        { ident: 'causeCode', display: 'Description', sortOrder: 'asc' },
      ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={130}
      onInsertEvent={b => setInsertEvent(b)}
      //  widthOffset={200}
      autoFixColByKey={false}
      headerRowHeight={30}
      afterSaveTask={afterSaveTask}
      defaultInsertData={{ causeCode: 0 }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  causeCodeMap: getCauseCodeMap(state),
})

const mapDispatchToMap = dispatch => ({
  saveCauseCode: causeCode =>
    dispatch({ type: CAUSE_CODE, payload: causeCode }),
  saveCauseCodeMap: map =>
    dispatch({ type: STORE_CAUSE_CODE_MAP, payload: map }),
  saveSystemCopmCauseCode: data =>
    dispatch({ type: STORE_UNIT_CAUSE_CODE_MAP, payload: data }),
})

// const mapDispatchToProps={{}}
export default connect(mapStateToProps, mapDispatchToMap)(SystemCompMgmt)
